import React from "react";
import { Redirect } from "react-router-dom";
import MonitorPerf from "./../pages/monitor/perf.js";
import OSSUpload from "./../pages/asset/oss-upload.js";
import Tiny from "./../pages/tool/tiny.js";

const routes = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to='/asset/oss-upload'/>,
  },
  {
    path: "/monitor/perf",
    exact: true,
    component: () => <Redirect to='/monitor/perf/mazey.net'/>,
  },
  {
    path: "/monitor/perf/:topic",
    title: "前端性能",
    component: () => <MonitorPerf />,
  },
  {
    path: "/asset/oss-upload",
    title: "OSS 上传",
    component: () => <OSSUpload />,
  },
  {
    path: "/tool/tiny",
    title: "短链接生成",
    component: () => <Tiny />,
  },
];

export default routes;
